/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import type * as Types from './graphql.schema-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export * from './graphql.schema-types';
export type MineOrganizationsQueryVariables = Exact<{ [key: string]: never }>;

export type MineOrganizationsQuery = {
  mineOrganizations: Array<{
    name: string | null;
    organizationId: string | null;
    roles: Array<Types.PermissionRole | null> | null;
    isSolo: boolean | null;
    isPremiumLab: boolean | null;
    isZalamoMarketDigitalCreator: boolean | null;
    isVatPayer: boolean | null;
    zalamoPayConfigFinished: boolean | null;
    zalamoPayRegisterInProgress: boolean | null;
    flags: { hideOrders: boolean | null; hideRevenue: boolean | null } | null;
  } | null> | null;
};

export const MineOrganizationsDocument = gql`
  query mineOrganizations {
    mineOrganizations {
      name
      organizationId
      roles
      isSolo
      isPremiumLab
      isZalamoMarketDigitalCreator
      flags {
        hideOrders
        hideRevenue
      }
      isVatPayer
      zalamoPayConfigFinished
      zalamoPayRegisterInProgress
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class MineOrganizationsGQL extends Apollo.Query<
  MineOrganizationsQuery,
  MineOrganizationsQueryVariables
> {
  document = MineOrganizationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
